import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { trackEvent } from 'dibs-tracking';
import ArrowIcon from 'dibs-vg/dist/react/arrow-right';

import styles from './SbRespVisuallySimilarLink.scss';

const trackLinkClick = function() {
    trackEvent({
        action: 'similar items clicked',
        label: 'none',
        category: 'results',
    });
};

export function SbRespVisuallySimilarLink({ itemId, isClient }) {
    if (!isClient) {
        return null;
    }

    return (
        <a className={styles.link} href={`/similar/?item=${itemId}`} onClick={trackLinkClick}>
            <FormattedMessage
                id="sb.SbRespVisuallySimilarLink.label"
                defaultMessage="Browse Similar"
            />
            <ArrowIcon className={styles.arrow} />
        </a>
    );
}

SbRespVisuallySimilarLink.defaultProps = {
    isClient: true,
};

SbRespVisuallySimilarLink.propTypes = {
    itemId: PropTypes.string,
    isClient: PropTypes.bool,
};
